import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/shared.css'; // 공용 폼/모달 — 항상 번들 맨 앞 (2026-08-10 충돌 정리)
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
